/* 注釈 */
import React from 'react';
import { Row } from 'react-bootstrap';

interface Props {
  text: string;
}

const Annotation: React.FC<Props> = ({ text }) => {
  return <Row className="annotation">{text}</Row>;
};

export default Annotation;
